import { init, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

/* render only necessary dropdowns and avoid duplicates */
let inputSelector, formSelector, dropdownSelector;
if(window.innerWidth < 1280) {
    inputSelector = '#header-search-mobile';
    formSelector = 'predictive-search[data-breakpoint="mobile"] form[action="/search"]';
    dropdownSelector = 'predictive-search[data-breakpoint="mobile"] div[data-predictive-search]';
} else {
    inputSelector = '#header-search';
    formSelector = 'predictive-search[data-breakpoint="desktop"] form[action="/search"]';
    dropdownSelector = 'predictive-search[data-breakpoint="desktop"] div[data-predictive-search]';
}

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: inputSelector,
    contentCssSelector: 'search-component[data-type="product"] #collection',
    formCssSelector: 'form[action="/search"]',
    dropdownCssSelector: dropdownSelector,
    // hitDecorators: [
    //     thumbnailDecorator({ size: "9" })
    // ],
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    serpPath: '/search',
    serpPathRedirect: window.location.pathname !== "/search",
    serpQuery: {
        products: {
            fields: [ 
                "productId", "url", "name", "skus.id",
                "skus.customFields.key", "skus.customFields.value" 
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url", "categories",
                "name", "tags1",
                // "thumbUrl", 
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value",
                "skus.inventoryLevel"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    persistentSearchCache: true,
    preservePageScroll: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: '.section--main-collection-product-grid #collection',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                fields: [ 
                    "productId", "url", "name", "skus.id", 
                    "skus.customFields.key", "skus.customFields.value"
                ],
                categoryId: this.categoryId(),
                facets: ["*"],
                size: defaultConfig.serpSize,
                from: 0
            }
        }
    },
})
.then(() => {
    // remove native search elements
    ['[data-backdrop]'].forEach(selector => { 
        document.querySelectorAll(selector).forEach(el => el.remove());
    })

    // remove styling
    const dropdownEl = document.querySelector(dropdownSelector);
    if(dropdownEl) {
        dropdownEl.className = ''; 
    }

    /* mobile search input focus */
    // const showVirtualKeyboard = (input) => {
    //     if(!input) return;

    //     const tempInput = document.createElement('input');
    //     tempInput.style.position = "absolute";
    //     tempInput.style.top = "30px";
    //     tempInput.style.left = "30px";
    //     tempInput.style.height = 0;
    //     tempInput.style.opacity = 0;
    //     document.body.appendChild(tempInput);
    //     tempInput.focus();

    //     setTimeout(() => {
    //         input.focus();
    //         input.click();
    //         document.body.removeChild(tempInput);
    //     }, 500)
    // }
    
    if(window.innerWidth < 1280) {
        const mobileInput = document.querySelector(inputSelector);
        const mobileSearchToggle = document.querySelector('[href="#search-dialog"]');
        if(mobileInput && mobileSearchToggle) {
            mobileSearchToggle.addEventListener('touchend', (e) => {
                // showVirtualKeyboard(mobileInput)
                setTimeout(() => {
                    mobileInput.focus();
                    mobileInput.click();
                }, 400)
            })
        }
    }
})
